import { Popover, Spin } from 'antd';
import { useContext, useState } from 'react';

import { useLazyGetEmployeeRecordsTipQuery } from '@app/api/Records/api';
import { TABLET, WARNING } from '@app/constants';
import { useUserPrint, useWindowSize } from '@app/hooks';
import { NotificationContext } from '@app/providers';
import { handleCatchError } from '@app/services';
import type { NRecords } from '@app/types';
import type { NEmployees } from '@app/types/Employees';

import { ScheduleDetails } from '@pages/WorkSchedule/components/ScheduleDetails';

import type { NWorkSchedule } from '@pages/WorkSchedule/WorkSchedule.types';

export const TipPopover: NWorkSchedule.TipPopover = ({
  children,
  employee,
  date,
}) => {
  const { showNotification } = useContext(NotificationContext);
  const { activeBranchId } = useUserPrint();
  const [isOpened, setOpeningStatus] = useState(false);
  const [tips, setTips] = useState<NRecords.ModelRecordTip[] | null>(null);
  const [isTipLoader, setTipLoader] = useState(false);
  const { innerWidth } = useWindowSize();
  const [getEmployeeRecordsTip] = useLazyGetEmployeeRecordsTipQuery();

  const getDetailsBySchedule = async (
    employeeId: NEmployees.Employee['Id'],
    date: string
  ) => {
    try {
      setTipLoader(true);
      const tips = await getEmployeeRecordsTip({
        ActiveBranchId: activeBranchId,
        employeeId,
        date,
      }).unwrap();
      setTips(tips);
    } catch (error) {
      showNotification(handleCatchError(error), WARNING);
    } finally {
      setTipLoader(false);
    }
  };

  return (
    <Popover
      open={isOpened}
      placement="rightBottom"
      content={
        <>
          {isTipLoader ? (
            <div
              style={{
                padding: '20px 0',
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
              }}
            >
              <Spin />
            </div>
          ) : (
            <ScheduleDetails
              data={tips}
              hideTips={() => setOpeningStatus(false)}
            />
          )}
        </>
      }
      trigger={innerWidth > TABLET ? 'hover' : 'click'}
      destroyOnHidden
      onOpenChange={(open) => {
        if (open) {
          setOpeningStatus(true);
          getDetailsBySchedule(employee.Id, date);
        } else {
          setOpeningStatus(false);
        }
      }}
      mouseEnterDelay={0.1}
    >
      {children}
    </Popover>
  );
};
